----------------------------------------------------------------------------------------------------------------------------------------------------------
* Componente base *
Chamada: <tagComponentePai v-model="dadoComponentePai"></tagComponentePai>
Retorno: [] Array de selects
Saída: O computed this.selectedLocal pode ter o setter modificado para intervenção no dado de retorno
Obs: 
- A prop "multi" é tratada no setter para manter a diretiva multi no componente autocomplete e, assim, ser mantido o formato de saída como Array
- Modificar o watcher de this.search para requisição na url desejada. (importar axios)
* Aceita props *
-----------------------------------------------------------------------------------------------------------------------------------------------------------
<template>
  <div>
    <v-autocomplete
      :append-icon="icon"
      multiple
      return-object
      v-model="selectedLocal"
      :items="items"
      :rules="rules"
      :loading="isLoading"
      :search-input.sync="search"
      chips
      clearable
      hide-details
      hide-selected
      item-text="name"
      item-value="id"
      :label="text"
      cache-items
      outlined
      color="secondary"
    >
      
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>{{listTitle}}</v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="secondary"
          class="white--text"
          v-on="on"
        >
          <v-icon left>mdi-account-circle</v-icon>
          <span v-text="item.email"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar size="20" color="indigo" class="headline font-weight-light white--text">
          <v-icon small dark>mdi-account</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.name"></v-list-item-title>
          <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  model: {
    prop: "selected",
    event: "selectedChange"
  },
  props: {
    listTitle: {
      type: String,
      default: "Escolha uma opção"
    },
    text: {
      type: String,
      default: "Escolha uma opção"
    },
    icon: {
      type: String,
      default: "mdi-menu-down"
    },
    rules: {
      // Envie como :rules="[ruleRequired('Campo obrigatório!')]" importado de mixins/validations no componente pai.
      type: Array,
      default: () => []
    },

    multi: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    items: [],
    search: null
  }),
  methods: {
    async setupSelected() {
      try {
        for (let index = 0; index < this.$attrs.selected.length; index++) {
          const emp = this.$attrs.selected[index];
          await this.setOneSelected(emp.id)
        }
      } catch (error) {
        console.error(error);
      }
    },
    async setOneSelected(employee_id){
      await Vue.axios
        .get(
          `/employees/${employee_id}`
        )
        .then(res => res.data)
        .then(res => {
          res = res.data? res.data.attributes : res
          this.items.push(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  computed: {
    selectedLocal: {
      get() {
        return this.$attrs.selected;
      },
      set(value) {
        if (this.multi === false && value.length > 1) {
          value.shift();
        }
        this.$emit("selectedChange", value);
      }
    }
  },
  mounted () {
    if (this.$attrs.selected && this.$attrs.selected.length>0){
      this.setupSelected()
    }
  },
  watch: {
    search(val) {
      if (val && val.length >= 3 && !this.isLoading){
        this.isLoading = true;
  
        // Lazily load input items
        Vue.axios.get(
          `/employees?solution_id=${localStorage.getItem(
            "solution_id"
          )}&query=${val}`
        )
        .then(res => res.data)
        .then(res => {
          this.items = res.data.map(o => o.attributes);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>